<template>
  <div class="blue">

    <!-- Success Message -->
    <transition name="fade" mode="out-in">
      <div
        v-if="sent"
        class="thanksBox"
      >
        <p class="thanksText">
          Thanks for contacting us, we will get back to you shortly...
        </p>
      </div>
    </transition>

    <!-- Form -->
    <template v-if="!sent">

      <b-form @submit.prevent="submitForm">

        <input
          type="hidden"
          name="subject"
          value="Flight Park Enquiry"
        >

        <b-row class="rowPadMob">

          <!-- Name -->
          <b-col
            md="6"
            sm="12"
            class="RightPad"
          >
            <b-form-input
              v-model="name"
              type="text"
              placeholder="Your Name"
              required
            />
          </b-col>

          <!-- Email -->
          <b-col
            md="6"
            sm="12"
            class="leftPad"
          >
            <b-form-input
              v-model="email"
              type="email"
              placeholder="Your Email Address"
              required
            />
          </b-col>

          <!-- Phone -->
          <b-col
            md="6"
            sm="12"
            class="RightPad"
          >
            <b-form-input
              v-model="phone"
              type="text"
              placeholder="Your Phone Number"
              required
            />
          </b-col>

          <!-- Dropdown -->
          <b-col
            md="6"
            sm="12"
            class="leftPad"
          >
            <b-form-select
              v-model="selected"
              :options="options"
              required
            />
          </b-col>

          <!-- Message -->
          <b-col
            md="12"
            sm="12"
          >
            <b-form-textarea
              v-model="message"
              rows="11"
              class="form-control enquiryForm"
              placeholder="Your Enquiry"
              required
            />
          </b-col>

          <!-- Error Message -->
          <b-col
            v-if="text"
            cols="12"
          >
            <p class="errorText">
              {{ text }}
            </p>
          </b-col>

          <!-- Submit -->
          <button
            type="submit"
            class="HomepageBtn"
            :class="{ disabled: !formValid || sending }"
            :disabled="!formValid || sending"
          >
            {{ sending ? 'Sending...' : 'Submit' }}
          </button>

          <!-- Turnstile -->
          <div
            ref="turnstile"
            class="turnstileContainer"
          ></div>

        </b-row>

      </b-form>

    </template>

  </div>
</template>

<script>
const WEB3FORMS_ACCESS_KEY =
  "35df1117-0cd8-457d-a9b2-17f5eeb54cd6";

export default {
  data() {
    return {
      website: "FlightPark Website Enquiry",

      name: "",
      email: "",
      phone: "",
      message: "",
      selected: null,

      options: [
        {
          value: null,
          text: "Please Select from the dropdown list"
        },
        {
          value: "Book a tour",
          text: "Book a tour"
        },
        {
          value: "Private and discreet booking",
          text: "Private and discreet booking"
        },
        {
          value: "Corporate membership",
          text: "Corporate membership"
        },
        {
          value: "Pay and play",
          text: "Pay and play"
        },
        {
          value: "Group membership",
          text: "Group membership"
        },
        {
          value: "General enquiry",
          text: "General enquiry"
        }
      ],

      text: "",
      sent: false,
      sending: false,

      turnstileToken: null,
      turnstileWidgetId: null
    };
  },

  computed: {
    formValid() {
      return (
        this.name.trim() !== "" &&
        this.email.trim() !== "" &&
        this.phone.trim() !== "" &&
        this.message.trim() !== "" &&
        this.selected !== null
      );
    }
  },

  methods: {

    loadTurnstile() {
      const checkTurnstile = setInterval(() => {

        if (
          window.turnstile &&
          this.$refs.turnstile
        ) {

          clearInterval(checkTurnstile);

          this.turnstileWidgetId =
            window.turnstile.render(
              this.$refs.turnstile,
              {
                sitekey: "0x4AAAAAAEtrRr92OBffj1xG",

                callback: (token) => {
                  console.log(
                    "Turnstile token received"
                  );

                  this.turnstileToken = token;
                },

                "expired-callback": () => {
                  console.log(
                    "Turnstile token expired"
                  );

                  this.turnstileToken = null;
                },

                "error-callback": (error) => {
                  console.error(
                    "Turnstile error:",
                    error
                  );

                  this.turnstileToken = null;

                  return true;
                }
              }
            );
        }

      }, 100);
    },


    async submitForm() {

      // Clear previous errors
      this.text = "";

      // Check form
      if (!this.formValid) {

        this.text =
          "Please complete all required fields.";

        return;
      }


      // Check Turnstile
      if (!this.turnstileToken) {

        this.text =
          "Please complete the security check.";

        return;
      }


      this.sending = true;


      try {

        const response = await fetch(
          "/api/contact",
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },

            body: JSON.stringify({

              access_key:
                WEB3FORMS_ACCESS_KEY,

              website:
                this.website,

              name:
                this.name,

              email:
                this.email,

              phone:
                this.phone,

              message:
                this.message,

              selected:
                this.selected,

              turnstileToken:
                this.turnstileToken

            })
          }
        );


        const result =
          await response.json();


        console.log(
          "Form response:",
          result
        );


        if (result.success) {

          this.sent = true;

          this.name = "";
          this.email = "";
          this.phone = "";
          this.message = "";
          this.selected = null;

          this.turnstileToken = null;

        } else {

          this.text =
            result.message ||
            "There was a problem submitting the form.";

          // Reset Turnstile
          this.resetTurnstile();

        }

      } catch (error) {

        console.error(
          "Form submission error:",
          error
        );

        this.text =
          "There was a problem submitting the form. Please try again.";

        this.resetTurnstile();

      } finally {

        this.sending = false;

      }

    },


    resetTurnstile() {

      if (
        window.turnstile &&
        this.turnstileWidgetId !== null
      ) {

        window.turnstile.reset(
          this.turnstileWidgetId
        );

      }

      this.turnstileToken = null;

    }

  },


  mounted() {

    this.loadTurnstile();

  }
};
</script>

<style scoped>

button.HomepageBtn.disabled,
button.HomepageBtn:disabled {
  background-color: #cccccc;
  border-color: transparent !important;
  cursor: not-allowed;
}

.errorText {
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.RightPad.col-md-6.col-6 {
  padding-right: 7px;
}

.leftPad.col-md-6.col-6 {
  padding-left: 7px;
}

.enquiryForm {
  margin-bottom: 70px !important;
  display: block;
}

select.custom-select {
  height: 51.5px;
  border-radius: 0;
  font-size: 18px;
  margin-bottom: 15px;
  color: #4E4E4E;
  font-style: italic;
}

button.HomepageBtn {
  background-color: #5d8ef0;
  border-color: #5d8ef0 !important;
  border-radius: 50px;

  width: 252px;
  height: 54px;

  color: #fff;

  font-size: 18px;
  font-weight: bold;

  margin: auto;

  text-align: center;
  display: block;

  font-family: "noto-sans", sans-serif;
}

button.HomepageBtn:hover:not(:disabled) {
  background-color: #707070;
  border-color: #707070 !important;
}

textarea.form-control {
  height: 130px;
}

.thanksBox {
  text-align: center;
  border: 5px solid #fff;
  margin-top: 0;
}

.thanksText {
  font-size: 24px;
  color: #fff;
  margin-top: 1rem;
}

.blue {
  background-size: cover;
  padding-bottom: 5%;
  text-align: left;
}

::v-deep .form-control {
  font-size: 18px;
  border-radius: 0;
  margin-bottom: 15px;
  padding: 1.575rem 0.75rem;
  color: #4E4E4E;
  font-style: italic;
}

.form-control::placeholder {
  color: #4E4E4E;
  opacity: 1;
}

@media only screen and (max-width: 768px) {

  .enquiryForm {
    margin-bottom: 30px !important;
  }

  .rowPadMob {
    padding-left: 30px;
    padding-right: 30px;
  }

}

</style>